import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { OnyxWordmark } from "@/components/site/Brand";
import { useAuth } from "@/context/AuthContext";
import { MEDIA } from "@/lib/media";

export default function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (location.state?.error === "not_admin") toast.error("This account is not authorized for admin access.");
    if (location.state?.error === "failed") toast.error("Sign-in failed. Please try again.");
  }, [location.state]);

  useEffect(() => { if (user?.is_admin) navigate("/admin", { replace: true }); }, [user, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-onyx-black text-white">
      <div className="relative hidden lg:block">
        <img src={MEDIA.darkGlassStair} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
        <div className="absolute bottom-16 left-12 right-12">
          <h2 className="font-display font-extrabold text-4xl xl:text-5xl tracking-tightest leading-none">Proposal Studio</h2>
          <p className="text-white/50 mt-4 max-w-sm">Build premium architectural proposals. Manage projects, customers, and pipeline in one place.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6">
        <div className="w-full max-w-sm">
          <OnyxWordmark dark className="mb-12" />
          <span className="text-[11px] tracking-[0.3em] uppercase text-onyx-wood">Admin Access</span>
          <h1 className="font-display font-extrabold text-4xl tracking-tightest mt-4">Sign in to continue.</h1>
          <p className="text-white/50 mt-4">Secure access for the ONYX team.</p>
          <button onClick={login} data-testid="google-login-btn" className="mt-10 w-full bg-white text-onyx-black py-4 flex items-center justify-center gap-3 text-sm font-medium hover:bg-onyx-wood transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <p className="text-white/30 text-xs mt-6 text-center">Authorized ONYX personnel only.</p>
        </div>
      </div>
    </div>
  );
}
